module.exports = __webpack_public_path__ + "img/gift.ed8d46e4.svg";